import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, formatDate } from "helpers/row-logic-helper";

import { shouldShowEstDevelopmentCost, shouldShowPricingGuidance, isClosedDeal, shouldSeeReadyForLenderIntegration } from "../deal-settings-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  dealName: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Deal Name", Cell: tableSideColumnMapper },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  projectTypeId: {
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Project Type", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.STRING, map: data => defaultField(data, "projectType.name"), Cell: tableSideColumnMapper }
    ]
  },
  pricingGuidance: {
    isVisible: data => shouldShowPricingGuidance(data),
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Pricing Guidance", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.DOLLAR, map: data => defaultField(data, "pricingGuidance"), Cell: tableSideColumnMapper }
    ]
  },
  estDevelopmentCost: {
    isVisible: data => shouldShowEstDevelopmentCost(data),
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Est. Development Cost", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.DOLLAR, map: data => defaultField(data, "estDevelopmentCost"), Cell: tableSideColumnMapper }
    ]
  },
  targetClosingDate: {
    isVisible: data => !isClosedDeal(data),
    cells: [
      { type: SIDE_TABLE_COLUMN_TYPES.COLUMN, width: DEFAULT_WIDTH, label: "Targeted Closing Date", Cell: tableSideColumnMapper },
      { type: SIDE_TABLE_COLUMN_TYPES.DOLLAR, map: data => formatDate(defaultField(data, "targetedClosing")), Cell: tableSideColumnMapper }
    ]
  }

};
